module.exports = __webpack_public_path__ + "img/ETP.09031b0f.svg";